import React from 'react';
import './BlockWrapper.scss';

export const BlockWrapper = ({
    title, children,
}) => (
    <div className='block-wrapper'>
        <h3 className='block-title'>{title}</h3>
        {children}
    </div>
);



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/common/BlockWrapper.jsx